var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.xAxisScroll)?_c('horizontal-scroll-outer-wrapper',[_c('horizontal-scroll-inner-wrapper',{staticClass:"space-x-2"},[_c('div',{staticClass:"flex"},[_vm._t("default")],2)])],1):_c('div',{staticClass:"space-y-2 -mt-2"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }